import { BUTTON_STYLE_TYPES } from '~coreModules/core/js/constants';

export default {
    props: {
        errorText: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: null,
        },
        id: {
            type: String,
            default: null,
        },
        isDisabled: {
            type: [Boolean, String],
            default: false,
        },
        isRequired: {
            type: [Boolean, String],
            default: false,
        },
        isLight: {
            // indicates whether or not children of the group should have a light theme
            type: [Boolean, String],
            default: false,
        },
        radioButtonItems: {
            type: Array,
            default: () => [],
        },
        checkedItem: {
            type: [String, Number, Boolean],
            default: '',
        },
        modelValue: {
            type: [String, Number, Boolean],
            default: '',
        },
        buttonGroupClass: {
            type: String,
            default: '',
        },
        buttonItemClass: {
            type: String,
            default: '',
        },
        styleType: {
            type: String,
            default: '',
            validator: value => !value || Object.values(BUTTON_STYLE_TYPES).includes(value),
        },
    },
};
